module.exports = __webpack_public_path__ + "static/media/wlteam.0e59151d.mp4";